<template>
  <div class="page-login">
    <el-card class="login-card">
      <img
        :src="IconEableM"
        alt="이글M"
        class="logo"
      />
      <span
        v-if="envConfig.isStaging"
        class="staging-text"
      >Staging</span>
      <div class="sso-area">
        <template v-if="ssoErrorMessage">
          <p class="sso-error">
            {{ ssoErrorMessage }}
          </p>
          <el-button
            type="primary"
            @click="handleWorksLogin"
          >
            다시 로그인
          </el-button>
        </template>
        <p
          v-else
          class="sso-loading"
        >
          NAVER WORKS 로그인으로 이동 중...
        </p>
      </div>
    </el-card>
  </div>
</template>

<script setup lang='ts'>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { getEnvironmentConfig } from '@/utils/environment'
import IconEableM from '@/assets/images/logo-eaglem.svg';

const SSO_ERROR_MESSAGE: Record<string, string> = {
  no_code: '인증 코드를 받지 못했습니다.',
  token: '토큰 발급에 실패했습니다.',
  userinfo: '사용자 정보를 불러오지 못했습니다.',
  domain: '허용되지 않은 계정입니다. (4grit.com 계정만 로그인할 수 있습니다.)'
}

const envConfig = computed(() => getEnvironmentConfig());
const route = useRoute()

const ssoErrorMessage = computed(() => {
  const ssoError = route.query.ssoError
  if (!ssoError) return ''
  return SSO_ERROR_MESSAGE[ssoError as string] || 'NAVER WORKS 로그인에 실패했습니다.'
})

const handleWorksLogin = () => {
  const baseUrl = process.env.VUE_APP_API_BASE_URL || 'https://staging-eagle-api.beusable.net'
  window.location.href = `${baseUrl}/admin/user/sso?from=eaglem`
}

// SSO 인증 실패로 돌아온 경우엔 자동 리다이렉트하지 않고 에러를 표시(루프 방지)
if (!route.query.ssoError) {
  handleWorksLogin()
}
</script>
